<template>
  <span>
    {{ $t('brand.products.availabilityColumn.available') }}
  </span>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import Product from '@monolith/legacy/types/product';

export default defineComponent({
    name: 'ProductsTableAvailability',
    props: {
        product: {
            type: Object as () => Product,
            required: true,
        },
    },
});
</script>
